import { GlobalAxios } from "../axios/axios-config";

const MENUS_ROUTE = process.env.REACT_APP_API + "/api/menu";

export interface IMenu {
  id: string;
  parentId: string;
  DomainId: string;
  name: string;
  NormalizedName: string;
  description: string;
  NormalizedDescription: string;
  iconClass: string;
  link: string;
  target: string;
  order: number;
  enable: boolean;
}

export class MenusService {
  list = () => {
    return GlobalAxios.get<IMenu[]>(MENUS_ROUTE);
  };
}

export default MenusService;
